import { useRef, useEffect, useState, useContext } from 'react';
import Link from 'next/link';

export default function SiteLayout({ children, global }) {

	return (
		<>
			<div className="c-page-wrapper">
				<div className="c-page-wrapper__inner">
					{children}
				</div>
				<div className="c-site-footer">
				</div>
			</div>			
		</>
	);
}
